/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { getMappingDatePriceData, getMappingDatePriceDataCalendar } from '@/components/RouteCompanyCityToCity/SectionManager';
import {
  generateDays, generateMinFareRequestSeo, getRangeCountTet, groupItemByDate,
} from '@/components/RoutePage/SectionManager/utils';
import WrapperSection from '@/components/RoutePage/SectionManager/WrapperSection';
import { TSelectedDate } from '@/slices/calendar';
// slices
import {
  TMinFareObj, TMinFareRequest,
  useLazyGetFlightByIdQuery, useLazyGetFlightDataQuery, useLazyGetFlightStatisticsQuery, useLazyGetFlightStatisticsSeoRoute2Query, useLazyGetFlightStatisticsSeoRouteQuery,
} from '@/slices/flightData/apis/flightDataApi';
import { resetSelectedContact } from '@/slices/passenger/slices/passengerSlice';
import { addFlight } from '@/slices/selectedFlight/slices/selectedFlightSlice';
import { mappingCompanySlugToCode } from '@/utils/airlineMapping';
import { tetDays, TET_MONTH, TET_YEAR } from '@/utils/constants';
import { TGenerateFlightCountRequest } from '@/utils/generateFlightRequest';
// utils
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { matchPriceOrDash } from '@/utils/matchPriceOrDash';
import { monthYears } from '@/utils/monthYears';
import { pr } from '@/utils/pxToRem';
import { Stack, Box } from '@mui/material';
import { format } from 'date-fns';
import {
  get, isEmpty, minBy, uniq,
} from 'lodash';
import moment from 'moment';
import { useRouter } from 'next/router';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { CONTENT_SECTION, TABLE_FARE } from '../constants';
import {
  IGroupedByFlightNameSeoRoute, ItemSeoRoute,
} from './type';

const formatDate = (date: Date) => format(date, 'yyyy-MM-dd');

interface ISectionManager {
  sxWrapper?: {
    [key: string]: any
  },
  hasBorder?: boolean | undefined,
  data: any,
  idComponent: string | undefined,
  title: string | undefined,
  content?: {
    [key: string]: any
  },
  routeName: string,
  routeName2: string,
  company: string,
  companySlug: string,
  startPointHome: any,
  toPointHome: any,
  routeCode: string,
  branchPage: any,
  routeCodeReturn: string,
  onSearchFlight: (date: TSelectedDate) => void,
  isDesktop?: boolean;
  countSeoResult?: any;
}

function SectionManager(props: Partial<ISectionManager>) {
  const {
    sxWrapper, idComponent, routeName, routeName2, routeCode, onSearchFlight, routeCodeReturn, company, companySlug, branchPage, isDesktop, countSeoResult, startPointHome, toPointHome,
  } = props;
  const router = useRouter();
  const [getFlightDepartById, { data: flightById }] = useLazyGetFlightByIdQuery();

  let startPoint = useAppSelector((state) => state.searchFlightForm.startPointHome);
  let toPoint = useAppSelector((state) => state.searchFlightForm.toPointHome);
  const dispatch = useAppDispatch();
  const [
    getFlightStatisticsSeoRoute,
    {
      isFetching: isFetchingStatisticsSeo,
      currentData: dataStatisticsSeo,
      error: errorStatisticsSeo,
    },
  ] = useLazyGetFlightStatisticsSeoRouteQuery();

  const [
    getAllFlightStatisticsSeoRoute,
    {
      currentData: dataAllFlightStatisticsSeo,
    },
  ] = useLazyGetFlightStatisticsSeoRouteQuery();

  const [
    getFlightStatisticsSeoTetRoute,
    {
      isFetching: isFetchingStatisticsTetSeo,
      currentData: dataStatisticsTetSeo,
      error: errorStatisticsTetSeo,
    },
  ] = useLazyGetFlightStatisticsSeoRouteQuery();

  const [
    getFlightStatisticsSeoRoute2,
    {
      currentData: dataStatisticsSeoReturn,
    },
  ] = useLazyGetFlightStatisticsSeoRoute2Query();

  const [
    getFlightData,
  ] = useLazyGetFlightDataQuery();

  const [getMinFare, { data: dataStatistics }] = useLazyGetFlightStatisticsQuery();
  const [getTetMinFare, { data: countTetResult }] = useLazyGetFlightStatisticsQuery();

  const { passenger } = useAppSelector((state) => state.searchFlightForm);
  const [selectedDate, setSelectedDateState] = useState(moment().toISOString());

  const fromAirports = startPoint?.airports?.map((airport) => airport.airportCode) || [];
  const toAirports = toPoint?.airports?.map((airport) => airport.airportCode) || [];

  const days = generateDays({
    date: selectedDate,
    minDate: moment().toISOString(),
    maxDate: moment().add(30, 'days').toISOString(),
  });
  const allAirlineDays = generateDays({
    date: selectedDate,
    minDate: moment().toISOString(),
    maxDate: moment().add(30, 'days').toISOString(),
  });

  const dataGroup = dataStatisticsSeo ? groupItemByDate(dataStatisticsSeo as any, routeCode as string) : null;
  const allAirlineDataGroup = dataAllFlightStatisticsSeo ? groupItemByDate(dataAllFlightStatisticsSeo as any, routeCode as string) : null;
  const groupedByLlightNameSeoRoute: IGroupedByFlightNameSeoRoute | undefined = dataStatisticsSeo?.grouped_by_flight_name_seo_route;
  let dataObj = groupedByLlightNameSeoRoute && routeCode ? groupedByLlightNameSeoRoute[routeCode] : {} as ItemSeoRoute;

  const groupedByLlightNameSeoRoute2: IGroupedByFlightNameSeoRoute | undefined = dataStatisticsSeoReturn?.grouped_by_flight_name_seo_route;
  const dataObjReturn = groupedByLlightNameSeoRoute2 && routeCodeReturn ? groupedByLlightNameSeoRoute2[routeCodeReturn] : {} as ItemSeoRoute;
  dataObj = {
    ...dataObj,
    lowest_round_flight_price: (dataObj?.lowest_price || 0) + (get(dataObjReturn, 'lowest_price') || 0),
  };

  const groupedByFlightNameSeoRoute = get(countSeoResult, 'grouped_by_flight_name_seo_route');
  if (!isEmpty(groupedByFlightNameSeoRoute)) {
    dataObj = Object.values(groupedByFlightNameSeoRoute)[0] as any;
    startPoint = TABLE_FARE[0].fromData as any;
    toPoint = TABLE_FARE[0].toData as any;
  }

  const daysInNewYears = getMappingDatePriceData(dataStatisticsTetSeo);
  const findDayNewYear = tetDays.find((day) => (day.monthVN === 1 && day.dayVN === 1));

  useEffect(() => {
    if (!startPoint || !toPoint) {
      return;
    }
    const flightRequestObject = generateMinFareRequestSeo({
      fromDateStr: flightRequest.fromDate,
      toDateStr: flightRequest.toDate,
      startPoint,
      toPoint,
      passenger,
      // airline: mappingCompanySlugToCode(companySlug || ''),
    });
    const allFlightRequestObject = generateMinFareRequestSeo({
      fromDateStr: flightRequest.fromDate,
      toDateStr: flightRequest.toDate,
      startPoint,
      toPoint,
      passenger,
    });

    const flightRequestTetObject = generateMinFareRequestSeo({
      fromDateStr: new Date('2025-01-01').toISOString(),
      toDateStr: new Date('2025-01-31').toISOString(),
      startPoint,
      toPoint,
      is_count_tet_price: 1,
      passenger,
      // airline: companySlug,

    });

    const flightRequestObjectReturn = generateMinFareRequestSeo({
      fromDateStr: flightRequest.fromDate,
      toDateStr: flightRequest.toDate,
      startPoint: toPoint,
      toPoint: startPoint,
      passenger,
      // airline: mappingCompanySlugToCode(companySlug || ''),
    });
    getMinFare(flightRequestStatistics);
    getTetMinFare(flightTetRequestStatistics);
    getFlightStatisticsSeoRoute(flightRequestObject);
    getFlightStatisticsSeoRoute2(flightRequestObjectReturn);
    getFlightStatisticsSeoTetRoute(flightRequestTetObject);
    getAllFlightStatisticsSeoRoute(allFlightRequestObject);
  }, [startPoint, toPoint]);

  useEffect(() => {
    if (daysInNewYears?.length) {
      daysInNewYears.forEach((element) => {
        getFlightData({
          from: fromAirports,
          to: toAirports,
          flight_class: 'PT',
          date: element?.dateStr || format(new Date(selectedDate), 'yyyy-MM-dd'),
        });
      });
    }
  }, [daysInNewYears?.length]);

  const handleSelectDate = (date: Date) => {
    setSelectedDateState(date.toISOString());
  };

  const { startDate, endDate } = getRangeCountTet();

  const flightRequest: TMinFareRequest = {
    from: fromAirports,
    to: toAirports,
    fromDate: days ? formatDate(days[0].date) : formatDate(new Date()),
    toDate: days ? formatDate(days[days.length - 1].date) : formatDate(new Date()),
    mode: 'flight',
  };

  const flightRequestStatistics: TGenerateFlightCountRequest = {
    from: fromAirports,
    to: toAirports,
    month_years: monthYears(),
    flight_class: 'PT',
    // disable_update_filter: 1,
  };

  const flightTetRequestStatistics: TGenerateFlightCountRequest = {
    from: fromAirports,
    to: toAirports,
    flight_class: 'PT',
    date_range: {
      min: startDate,
      max: endDate,
    },
    is_count_tet_price: 1,

    // disable_update_filter: 1,
  };

  useEffect(() => {
    if (flightById) {
      const from = startPoint?.airports[0]?.nameVn;
      const to = toPoint?.airports[0]?.nameVn;
      dispatch(addFlight(flightById));
      const stringParams = {
        from,
        to,
        date: {
          depart: flightById?.route?.departureDate ? flightById?.route?.departureDate : selectedDate,
        },
        passenger: {
          adt: 1,
          chd: 0,
          inf: 0,
        },
        seatClass: 'PT',
      };
      router.push(`/trip-detail?${qs.stringify(stringParams)}&flightId[depart]=${flightById?.idIndex}`);
    }
  }, [flightById]);

  const dayPriceObj: any = {};
  if (dataGroup) {
    days.forEach((item: any) => {
      const key = item.dateStr;
      const matchDate = dataGroup[key] ? minBy(dataGroup[key], 'total_price_adult') : 0;
      item.minFare = matchPriceOrDash(!matchDate ? 0 : Math.round(matchDate.total_price_adul / 1000));
      item.time = matchDate ? matchDate.pickup_time : '';
      item.averageMinfare = matchDate ? matchDate.total_price_adult : '';
      item.airline = matchDate ? matchDate.airline : {};
      item.id = matchDate?.id;
      item.pickup_time = matchDate?.pickup_time;
      item.dropoff_time = matchDate?.dropoff_time;
      dayPriceObj[key] = matchDate ? matchDate.total_price_adult : '';
    });
  }
  if (allAirlineDataGroup) {
    allAirlineDays.forEach((item: any) => {
      const key = item.dateStr;
      const matchDate = allAirlineDataGroup[key] ? minBy(allAirlineDataGroup[key], 'total_price_adult') : 0;
      item.minFare = matchPriceOrDash(!matchDate ? 0 : Math.round(matchDate.total_price_adult / 1000));
      item.time = matchDate ? matchDate.pickup_time : '';
      item.averageMinfare = matchDate ? matchDate.total_price_adult : '';
      item.airline = matchDate ? matchDate.airline : {};
      item.id = matchDate?.id;
      item.pickup_time = matchDate?.pickup_time;
      item.dropoff_time = matchDate?.dropoff_time;
    });
  }

  const dayPriceObjStatictis = {} as TMinFareObj;
  dataStatistics?.forEach((group, idx) => {
    Object.keys(group?.grouped_by_date).forEach((groupedDate) => {
      dayPriceObjStatictis[groupedDate] = group?.grouped_by_date[groupedDate].min_fare;
    });
  });
  // if (!startPoint || !toPoint) return null;

  const handleSelectTrip = (item: any) => {
    if (item?.id) {
      getFlightDepartById({ id: item?.id });
    }
    dispatch(resetSelectedContact());
  };

  const airlinesInNewYears = uniq((daysInNewYears.filter((item) => !!item?.airline?.name).map((item) => item?.airline?.name) || []));
  const airlinesAll = uniq((days.filter((item) => !!item?.airline?.name).map((item) => item?.airline?.name) || []));
  const renderComponent = ({ section }: any) => {
    const Component = section.component;
    if (!Component) {
      return null;
    }
    return (
      <Component
        isLoading={isFetchingStatisticsTetSeo}
        isDesktop={isDesktop}
        days={days}
        companyType={branchPage?.type}
        allAirlineDays={allAirlineDays}
        isCompanyCityCity={companySlug !== ''}
        company={company}
        companySlug={companySlug}
        startPoint={startPointHome}
        toPoint={toPointHome}
        branchPage={branchPage}
        daysInNewYears={daysInNewYears}
        selectedDate={selectedDate}
        dayTetPriceObjs={getMappingDatePriceDataCalendar(countTetResult || {})}
        handleSelectDate={handleSelectDate}
        isFetching={isFetchingStatisticsSeo}
        errorStatistics={errorStatisticsSeo}
        flightData={dataGroup}
        allAirlineFlightData={allAirlineDataGroup}
        handleSelectTrip={handleSelectTrip}
        routeName={`${startPoint?.location} - ${toPoint?.location}`}
        dayPriceObj={dayPriceObj}
        dayPriceObjStatictis={dayPriceObjStatictis}
        dataObj={dataObj}
        onSearchFlight={onSearchFlight}
        airlines={section.isNewYear ? airlinesInNewYears : airlinesAll}
        findDayNewYear={findDayNewYear}
      />
    );
  };
  return (
    <Stack
      sx={{
        ...sxWrapper,
        ...container,

        background: 'white',
      }}
      spacing={pr`24px`}
      id={idComponent}
    >
      {Object.values(CONTENT_SECTION({ isDesktop })).map((section, index) => {
        if (index === 0) {
          return (
            <>
              <WrapperSection
                isDesktop={isDesktop}
                key={0}
                section={section}
                dataObj={dataObj}
                titleComponent={section.title.component}
                idComponent={(section as any).id}
                airlines={airlinesAll}
                toPointHome={toPoint}
                startPointHome={startPoint}
                routeName={routeName}
                routeName2={routeName2 || ''}
                company={company}
                isHaveDivider={(section as any).isHaveDivider!}
              >
                <Box
                  sx={{
                    padding: (section as any).alignCenter && isDesktop ? {
                      xs: '16px 24px',
                      md: '16px 24px',
                      lg: '16px 144px',
                    } : {},
                  }}
                >
                  {renderComponent({ section })}
                </Box>
              </WrapperSection>
            </>

          );
        }
        return (
          <WrapperSection
            isDesktop={isDesktop}
            key={1}
            section={section}
            dataObj={dataObj}
            titleComponent={section.title.component}
            idComponent={(section as any).id}
            airlines={airlinesAll}
            toPointHome={toPoint}
            startPointHome={startPoint}
            routeName={routeName}
            routeName2={routeName2 || ''}
            company={company}
            isHaveDivider={(section as any).isHaveDivider!}
          >
            <Box
              sx={{
                padding: (section as any).alignCenter && isDesktop ? {
                  xs: '16px 24px',
                  md: '16px 24px',
                  lg: '16px 144px',
                } : {},
              }}
            >
              {renderComponent({ section })}
            </Box>
          </WrapperSection>
        );
      })}
    </Stack>
  );
}
const container = {
};

export default React.memo(SectionManager);
